// extracted by mini-css-extract-plugin
export var actions = "_rg-4";
export var item = "_rg-1";
export var price = "_rg-3";
export var quantity = "_rg-2";
export var table = "_rg-0";